import { Modal } from "antd";
import { ReactSVG } from "react-svg";
import BillingWelcomeNotice from "../../components/BillingWelcomeNotice";
import BackupSubscriptionInfo from "../../components/BackupSubscriptionInfo";
import QuickBooksConnectButton from "../../components/QuickBooksConnectButton";

const providers = [
  {
    key: "xero",
    name: "Xero",
    description: "Connect your Xero account to backup and restore organizations.",
    icon: "/assets/icons/xero.svg",
    color: "#13B5EA",
  },
  {
    key: "qbo",
    name: "QuickBooks Online",
    description:
      "Connect your QuickBooks Online company to backup and restore organizations.",
  },
];

const AddOrgTypeModal = ({ open, onClose, onSelect }) => {
  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-2xl font-semibold">
          Add New Organization
          <BackupSubscriptionInfo />
        </div>
      }
      centered
      open={open}
      footer={null}
      onCancel={onClose}
      width={520}
    >
      <p className="text-gray-500 text-sm mb-6">
        Choose the accounting platform you want to connect:
      </p>

      <div className="flex flex-col gap-3">
        {providers.map((provider) =>
          provider.key === "qbo" ? (
            <div
              key={provider.key}
              className="flex flex-col gap-4 p-4 border-2 border-gray-200 rounded-xl"
            >
              <div className="min-w-0">
                <h3 className="font-semibold text-gray-900 text-base">
                  {provider.name}
                </h3>
                <p className="text-gray-500 text-sm mt-1">
                  {provider.description}
                </p>
              </div>
              <QuickBooksConnectButton onClick={() => onSelect(provider.key)} />
            </div>
          ) : (
            <div
              key={provider.key}
              className="flex items-center gap-4 p-4 border-2 border-gray-200 rounded-xl cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all duration-200"
              onClick={() => onSelect(provider.key)}
            >
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: provider.color + "15" }}
              >
                <ReactSVG
                  src={provider.icon}
                  className="w-7 h-7"
                  beforeInjection={(svg) => {
                    svg.setAttribute("width", "28");
                    svg.setAttribute("height", "28");
                  }}
                />
              </div>

              <div className="flex-1">
                <h3 className="font-semibold text-gray-900 text-base">
                  {provider.name}
                </h3>
                <p className="text-gray-500 text-sm mt-0.5">
                  {provider.description}
                </p>
              </div>

              <svg
                className="w-5 h-5 text-gray-400 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          )
        )}
      </div>

      <BillingWelcomeNotice variant="compact" className="mt-5" />
    </Modal>
  );
};

export default AddOrgTypeModal;
